import type { Variables } from '../../themes/ThemeTypes';

import colors from './colors';

export const variables: Variables = {
  primary: colors.primary,
  dark: colors.dark,
  light: colors.light,

  white: colors.white,
  black: colors.black,
  offWhite: colors.offWhite,

  primaryHover: colors.primaryHover,

  error: colors.error,
  success: colors.success,

  primaryGradient: colors.gradients.primary,
  secondaryGradient: colors.gradients.secondary,
  successGradient: colors.gradients.success,
  dangerGradient: colors.gradients.danger,
  warningGradient: colors.gradients.warning,
  infoGradient: colors.gradients.info,
  appGradient: colors.gradients.app,
  electricityGradient: colors.gradients.electricity,
  heatingGradient: colors.gradients.heating,
  carGradient: colors.gradients.car,
  solarGradient: colors.gradients.solar,
};

export default variables;
